import type Address from '~/types/Address';

import api from '~/services/api';
import { type JSONAPIAddress } from '~/types/APIAddress';

export const getApiAddresses = () =>
  api.request<{ results: JSONAPIAddress[] }>({
    method: 'GET',
    params: {
      results: 100,
    },
    url: '/ui/user_addresses',
  });

export const createApiAddress = (address: JSONAPIAddress) =>
  api.request<JSONAPIAddress>({
    data: {
      ...address,
      hard_validate: true, // Enforces hard validation on City/State/Zip fields
    },
    method: 'POST',
    url: '/ui/user_addresses',
  });

export const editApiAddress = (
  id: number | string,
  address: JSONAPIAddress,
  shouldValidate = true,
) =>
  api.request<JSONAPIAddress>({
    data: {
      ...address,
      hard_validate: shouldValidate, // if true, enforces hard validation on City/State/Zip fields
    },
    method: 'PUT',
    url: `/ui/user_addresses/${id}`,
  });

export const deleteApiAddress = (id: number | string) =>
  api.request({
    method: 'DELETE',
    url: `/ui/user_addresses/${id}`,
  });

export const confirmAddress = (id: Address['objectId']) =>
  api.request({
    data: {
      is_confirmed_by_user: true,
    },
    method: 'PATCH',
    url: `/addresses/${id}`,
  });
